import type BannerBlock from '@/blocks/def/banner-block'

export default {
  blockType: 'banner',
  title: 'THE SILVER RUSH IS HERE',
  bylineBefore: 'Join the global rush to own silver!',
  skuPath: 'LXM-AG'
} satisfies BannerBlock
